// =============================================================================
// Bootstrap action constants — Phase 2.
//
// BOOTSTRAP_READY  — only transition into the terminal 'ready' phase.
//                    Idempotent: bootstrapReducers ignores when already ready.
//
// BOOTSTRAP_RESET  — flips phase back to 'inactive'. Provided so future soft
//                    logout/login flows (Phase 4+) do NOT inherit a stale
//                    'ready' phase across account switches that don't reload
//                    the page. Today there is no consumer; the affordance
//                    exists so when AUTH_LOGOUT lands in Phase 4 it can
//                    cascade into BOOTSTRAP_RESET (and then re-dispatch
//                    bootstrapApp() to refetch identity for the new session).
//
//                    Constraint for any future caller: dispatch BOOTSTRAP_RESET
//                    only AFTER the previous bootstrap has settled (state.
//                    bootstrap.phase === 'ready'). Resetting mid-flight does
//                    not cancel the in-flight thunk; its eventual completion
//                    will dispatch BOOTSTRAP_READY again, racing the reset.
// =============================================================================

export const BOOTSTRAP_READY = 'BOOTSTRAP_READY';
export const BOOTSTRAP_RESET = 'BOOTSTRAP_RESET';
